var _rect, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHowToReg(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "how_to_reg"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_538_5278",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 64,
    height: 64
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Bounding box",
    width: 64,
    height: 64,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_538_5278)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "how_to_reg_2",
    d: "M41.1333 53.4757L32.8564 45.1988L35.6666 42.3886L41.1333 47.8553L54.6 34.3886L57.4101 37.1988L41.1333 53.4757ZM26.5897 31.1782C24.0231 31.1782 21.8259 30.2643 19.9981 28.4366C18.1704 26.6088 17.2565 24.4116 17.2565 21.845C17.2565 19.2783 18.1704 17.0811 19.9981 15.2534C21.8259 13.4256 24.0231 12.5117 26.5897 12.5117C29.1563 12.5117 31.3535 13.4256 33.1813 15.2534C35.0091 17.0811 35.923 19.2783 35.923 21.845C35.923 24.4116 35.0091 26.6088 33.1813 28.4366C31.3535 30.2643 29.1563 31.1782 26.5897 31.1782ZM33.523 36.1322L24.4564 45.1988L30.769 51.4859H6.58984V45.5577C6.58984 44.1423 6.94624 42.9056 7.65904 41.8475C8.37184 40.7894 9.318 39.9612 10.4975 39.3629C12.7642 38.2074 15.1573 37.2723 17.6769 36.5578C20.1966 35.8433 23.1675 35.4861 26.5897 35.4861C27.923 35.4861 29.1632 35.5399 30.3102 35.6476C31.4572 35.7553 32.5281 35.9168 33.523 36.1322Z",
    fill: "#333333"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHowToReg);
export default __webpack_public_path__ + "static/media/how_to_reg.fdd389554cc99076b4e06e2861b1d431.svg";
export { ForwardRef as ReactComponent };